<iframe #frameElement [src]="iframeSrc | safe : 'resourceUrl'"
        [style.height]="iframeHeight"></iframe>
